/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrganizationDetailRequest } from '../types/PatchedOrganizationDetail';
import type { OrganizationDetailResponse } from '../types/OrganizationDetail';

export type OrganizationsPartialUpdateRequest = PatchedOrganizationDetailRequest;
export type OrganizationsPartialUpdateResponse = OrganizationDetailResponse;

export type OrganizationsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this organization.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_partial_update
 * tags:
 *   - organizations
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationDetail'
 *     description: ''
 * ```
 */
export const organizationsPartialUpdateOperation = ({
  id,
  ...rest
}: OrganizationsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/organizations/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/organizations/{id}/' };
  };

/**
 * PATCH /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_partial_update
 * tags:
 *   - organizations
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrganizationDetail'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationDetail'
 *     description: ''
 * ```
 */
export const organizationsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrganizationsPartialUpdateQuery;
  request: PatchedOrganizationDetailRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrganizationDetailResponse>> => {
  const operation = organizationsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
